package com.gsb.vyapar.bhagya.presentation.auth.uistate

import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.presentation.auth.util.formatSecondsToHHMM

data class AuthUiState(
    val isEmail: Boolean = false,
    val isOtpSent: Boolean = false,
    val remainingTime: Int = 120,
    val genOtp: String? = null,
    val genOtpEmail: String? = null,
    val genOtpMobile: String? = null,
    val timerEnabled: Boolean = false,
) {
    fun resetAuthUiState(isEmail: Boolean) {
        updateAuthUiState(this.copy(
            isEmail = isEmail,
            isOtpSent = false,
            remainingTime = 120,
            genOtp = null,
            genOtpEmail = null,
            genOtpMobile = null,
            timerEnabled = false,
        ))
    }

    fun resetAuthUiState() {
        updateAuthUiState(this.copy(
            isOtpSent = false,
            remainingTime = 120,
            genOtp = null,
            genOtpEmail = null,
            genOtpMobile = null,
            timerEnabled = false,
        ))
    }

    fun getRemainingTimeString(): String {
        return remainingTime.formatSecondsToHHMM()
    }

    fun setRemainingTime(remainingTime: Int) {
        updateAuthUiState(this.copy(
            remainingTime = remainingTime
        ))
    }

    fun setTimerEnabled(timerEnabled: Boolean) {
        updateAuthUiState(this.copy(
            timerEnabled = timerEnabled
        ))
    }

    fun sendEmailOtpSuccess(genOtp: String, genOtpEmail: String) {
        updateAuthUiState(this.copy(
            isOtpSent = true,
            genOtp = genOtp,
            genOtpEmail = genOtpEmail,
        ))
    }

    fun sendMobileOtpSuccess(genOtp: String, genOtpMobile: String) {
        updateAuthUiState(this.copy(
            isOtpSent = true,
            genOtp = genOtp,
            genOtpMobile = genOtpMobile,
        ))
    }
}

fun updateAuthUiState(authUiState: AuthUiState) {
    updateState(getState().copy(authUiState = authUiState))
}

fun getAuthUiState(): AuthUiState {
    return getState().authUiState
}